import Media from 'react-media';
import { Modal, useTheme } from '@simplywallst/ui-core';
import loadable from '@loadable/component';

const DesktopOnboardingContent = loadable(
  () => import('./DesktopOnboardingContent'),
  { resolveComponent: (component) => component.DesktopOnboardingContent }
);

const MobileOnboardingContent = loadable(
  () => import('./MobileOnboardingContent'),
  { resolveComponent: (component) => component.MobileOnboardingContent }
);

type Props = {
  completeOnboarding: () => void;
};

export const OnboardingContent = ({ completeOnboarding }: Props) => {
  const theme = useTheme();
  return (
    <Modal isNaked removeWindowScroll={false}>
      <Media query={{ maxWidth: theme.mdMin }}>
        {(match) => {
          return match ? (
            <MobileOnboardingContent completeOnboarding={completeOnboarding} />
          ) : (
            <DesktopOnboardingContent completeOnboarding={completeOnboarding} />
          );
        }}
      </Media>
    </Modal>
  );
};
